import { createFileRoute } from '@tanstack/react-router';

import { NewsScreen } from '../../features/personal/NewsScreen';

/** `/personal/news` = الأخبار (خطة القسم الشخصي ش9). */
export const Route = createFileRoute('/personal/news')({ component: NewsScreen });
